export type SafeStorageReadResult =
  | { value: string | null; failed: false }
  | { value: null; failed: true };

export interface SafeStorage {
  getItem(key: string): string | null;
  getItemWithStatus(key: string): SafeStorageReadResult;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

/** localStorageの利用不能時もアプリを継続できるstorageを取得 */
export function getSafeLocalStorage(): SafeStorage | undefined {
  try {
    const storage = globalThis.localStorage;
    if (!storage) return undefined;

    function getItemWithStatus(key: string): SafeStorageReadResult {
      try {
        return { value: storage.getItem(key) ?? null, failed: false };
      } catch {
        return { value: null, failed: true };
      }
    }

    return {
      getItem(key: string): string | null {
        return getItemWithStatus(key).value;
      },
      getItemWithStatus,
      setItem(key: string, value: string): void {
        try {
          storage.setItem(key, value);
        } catch {
          // Web Storageが利用できなくてもReact本体は起動させる
        }
      },
      removeItem(key: string): void {
        try {
          storage.removeItem(key);
        } catch {
          // Web Storageが利用できなくてもReact本体は起動させる
        }
      },
    };
  } catch {
    return undefined;
  }
}
